/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Entity, EntityData, EntityFieldKey, EntityModel } from '@typescript-kit/data';

export class CommentFieldKey extends EntityFieldKey {
  static readonly COMPANY_ID = 'companyId';
  static readonly EMPLOYEE_ID = 'employeeId';
  static readonly TYPE = 'type';
  static readonly DATE = 'date';
  static readonly VALUE = 'value';
}

export interface CommentData extends EntityData {
  companyId?: string;
  employeeId?: string;
  type?: string;
  date?: string;
  value?: string;
}

export class Comment extends Entity implements CommentData {
  readonly companyId: string;
  readonly employeeId: string;
  readonly type: string;
  readonly date: string;
  readonly value: string;

  constructor(data: CommentData) {
    super(data);
    this.companyId = data.companyId;
    this.employeeId = data.employeeId;
    this.type = data.type;
    this.date = data.date;
    this.value = data.value;
  }
}

export class CommentModel extends EntityModel implements CommentData {
  static readonly KEYS = EntityModel.KEYS.concat(
    Object.keys(CommentFieldKey).map((key) => CommentFieldKey[key])
  );

  constructor(data: CommentData) {
    super(data, CommentModel.KEYS);
  }

  get employeeId(): string {
    return this.get(CommentFieldKey.EMPLOYEE_ID);
  }

  get type(): string {
    return this.get(CommentFieldKey.TYPE);
  }

  set type(value: string) {
    this.set(CommentFieldKey.TYPE, value);
  }

  get date(): string {
    return this.get(CommentFieldKey.DATE);
  }

  set date(value: string) {
    this.set(CommentFieldKey.DATE, value);
  }

  get value(): string {
    return this.get(CommentFieldKey.VALUE);
  }

  set value(value: string) {
    this.set(CommentFieldKey.VALUE, value);
  }

  protected setupValues(data: CommentData, exclusive: boolean): CommentData {
    if ((exclusive || 'value' in data) && data.value === undefined) {
      data.value = null;
    }
    return data;
  }
}
